import { types } from "./types";


export function userWorkoutAction (data) {
  return { type: types.USER_REPORT_TOTAL_WORKOUT, payload: data };
}

export function userStrengthAssessmentAction (data) {
  return { type: types.USER_REPORT_STRENGTH_ASSESSMENT, payload: data };
}

export function userGoalCountAction (data) {
  return { type: types.USER_REPORT_GOAL_COUNT, payload: data };
}

export function userWorkoutCompletedAction (message) {
  return { type: types.USER_REPORT_WORKOUT_COMPLETED, payload: message };
}

export function userExerciseWiseStrengthAssAction (message) {
  return { type: types.USER_REPORT_EXERCISE_WISE_STRENGTH_ASSESSMENT, payload: message };
}

export function userTotalWorkoutsByHour (message) {
  return { type: types.USER_REPORT_TOTAL_WORKOUTS_BY_HOUR, payload: message };
}


export function userQuickTrainWorkout (message) {
  return { type: types.USER_QUICKTRAIN_WORKOUT, payload: message };
}
